import { localNum } from "@faire/web--source/common/localization/localize";

import { getSettingTotalBrandCount } from "@faire/retailer-visitor-shared/settings/getSettingTotalBrandCount";
import { getSettingTotalRetailerCitiesCount } from "@faire/retailer-visitor-shared/settings/getSettingTotalRetailerCitiesCount";

/**
 * Returns formatted string with the number of brands we are currently
 * advertising that we have on our platform (ex. '5,000').
 */
export const getTotalBrandCount = (): string =>
  localNum(getSettingTotalBrandCount());

/**
 * Returns formatted string with the number of cities faire retailers are in which
 * we are currently advertising on our platform (ex. '60,000').
 */
export const getTotalCitiesCount = (): string =>
  localNum(getSettingTotalRetailerCitiesCount());
